export enum Parameters {
    FAQS = 'faqs',
    TIMELINE = 'timeline',
    TRANSLATION = 'translation',
    INDEXING_STATUS = 'indexing-status'
}
